import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, TextField } from "@mui/material";
import { useState } from "react";
import { DRPProvider } from "./context";
import { useDRP } from "./logics";
import { DRPPopover } from "./popover";
import type { OnChangeDateRange, TDateRangePickerTextField } from "./types";

export const DateRangePickerTextField = <Chip extends string = string>({
  value,
  onClose,
  views,
  chips,
  chip,
  defaultView,
  onChange,
  required,
  label,
  minDate,
  maxDate,
  endDateDisabled,
  ...props
}: TDateRangePickerTextField<Chip>) => {
  const [open, setOpen] = useState(false);

  const handleClose: OnChangeDateRange<Chip> = (range, chip) => {
    if (onClose) {
      onClose(range, chip);
    }
    setOpen(false);
  };

  const contextValues = useDRP<Chip>(
    open,
    value,
    onChange,
    defaultView,
    views,
    chips,
    chip,
    undefined,
    handleClose,
    required,
    minDate,
    maxDate,
    endDateDisabled
  );

  return (
    <DRPProvider {...contextValues}>
      <TextField
        size="small"
        {...props}
        label={
          typeof label === "string" ? (
            <Box
              sx={{
                pr: 0.5,
              }}
            >
              {label}
            </Box>
          ) : (
            label
          )
        }
        value={contextValues.inputValue}
        ref={(el) => contextValues.setAnchorEl(el)}
        onMouseDown={(e) => {
          if ((e.target as Element).localName === "input" || (e.target as Element).id === "CalendarTodayIcon") {
            e.preventDefault();
            setOpen(true);
          }
        }}
        slotProps={{
          input: {
            startAdornment: (
              <CalendarTodayIcon color="secondary" sx={{ mx: 1 }} fontSize="small" id="CalendarTodayIcon" />
            ),
            endAdornment: (
              <IconButton size="small" onClick={contextValues.handleClear}>
                <CloseIcon fontSize="small" />
              </IconButton>
            ),
            ...props.InputProps,
          },

          htmlInput: { ...props.inputProps, readOnly: true }
        }} />
      <DRPPopover />
    </DRPProvider>
  );
};
